








import { Component, Prop, Vue } from 'vue-property-decorator';
import { EmptyTitle, Progress } from './components';
import { IResult } from './types';

@Component({
  components: {
    EmptyTitle,
    Progress,
  },
})
export default class Result extends Vue implements IResult {
  @Prop({ type: Array, default: () => [] })
  readonly result!: Array<any>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/components/result/Result.vue